import React from 'react';

interface PlusIconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  className?: string;
}

const PlusIcon: React.FC<PlusIconProps> = ({ 
  width = 17, 
  height = 17, 
  fill = "#FF6F0F",
  className 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 17 17" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M7.5 15.7495V8.99902H0.749512C0.335298 8.99902 0 8.66373 0 8.24951C0 7.8353 0.335298 7.5 0.749512 7.5H7.5V0.749512C7.5 0.335298 7.8353 0 8.24951 0C8.66373 0 8.99902 0.335298 8.99902 0.749512V7.5H15.7495C16.1637 7.5 16.499 7.8353 16.499 8.24951C16.499 8.66373 16.1637 8.99902 15.7495 8.99902H8.99902V15.7495C8.99902 16.1637 8.66373 16.499 8.24951 16.499C7.8353 16.499 7.5 16.1637 7.5 15.7495Z" 
        fill={fill}
      />
    </svg>
  );
};

export default PlusIcon;











